import Hero, { HeroProps as THeroProps } from "./Hero";
export type HeroProps = THeroProps;
export default Hero;
